var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('ul', {
    staticClass: "domestic-organization"
  }, _vm._l(_vm.items, function (item, index) {
    return _c('li', {
      key: index
    }, [_c('v-row', {
      staticClass: "row--xxs"
    }, [_c('v-col', {
      attrs: {
        "cols": "12"
      }
    }, [_c('v-sheet', {
      staticClass: "px-16 py-8",
      attrs: {
        "color": "primary",
        "outlined": "",
        "rounded": "pill"
      }
    }, [_c('h4', {
      staticClass: "tit tit--sm primary--text line-height-1"
    }, [_vm._v(" " + _vm._s(item.type) + " ")])])], 1), _vm._l(item.children, function (child, index) {
      return _c('v-col', {
        key: index,
        attrs: {
          "cols": "12"
        }
      }, [_c('v-sheet', {
        staticClass: "domestic-organization__child",
        attrs: {
          "min-height": "70",
          "color": "#fafafa"
        }
      }, [_c('v-row', {
        staticClass: "page-text page-text--lg",
        attrs: {
          "align": "center"
        }
      }, [_c('v-col', {
        staticClass: "domestic-organization__name",
        attrs: {
          "cols": "10",
          "lg": "3",
          "order": "1"
        }
      }, [_vm._v(_vm._s(child.name))]), _c('v-col', {
        staticClass: "domestic-organization__tel",
        attrs: {
          "cols": "12",
          "lg": "3",
          "order": "3"
        }
      }, [_vm._v(" " + _vm._s(child.tel) + " ")]), _c('v-col', {
        staticClass: "domestic-organization__address",
        attrs: {
          "cols": "12",
          "lg": "",
          "order": "4"
        }
      }, [_vm._v(" " + _vm._s(child.address) + " ")]), child.link ? _c('v-col', {
        staticClass: "domestic-organization__link",
        attrs: {
          "cols": "2",
          "lg": "auto",
          "order": "2",
          "order-lg": "5"
        }
      }, [_c('v-btn', {
        attrs: {
          "href": child.link,
          "target": "_blank",
          "icon": "",
          "text": ""
        }
      }, [_c('v-img', {
        attrs: {
          "src": "/images/about/organization/icon-home.svg",
          "max-width": "24",
          "alt": "홈페이지로 이동"
        }
      })], 1)], 1) : _vm._e()], 1)], 1)], 1);
    })], 2)], 1);
  }), 0);

}
var staticRenderFns = []

export { render, staticRenderFns }